import type { RechercheQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
import { buildRechercheStore } from '../storeRechercheBuilder'

export const useRechercheDossierStore = buildRechercheStore<RechercheQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDossierStore',
  apiPath: '/dossiers',
})

